/**
 * Standard events bootstrap (Dawn 16), moved out of layout/theme.liquid so the
 * import of Shopify's standard-events.js is requested at low priority instead
 * of High from an inline module in the head (docs/lighthouse-baseline.md,
 * section 7). Behaviour is unchanged: the same import, the same global, the
 * same two custom elements with the same options, and the page view event on
 * DOMContentLoaded.
 *
 * Loaded as a module script from the head, so it runs in document order with
 * the deferred scripts that come after it: cart.js extends
 * window.StandardEvents.createViewEventElement at definition time and relies
 * on that order.
 */
import * as StandardEvents from 'https://cdn.shopify.com/storefront/standard-events.js';

window.StandardEvents = StandardEvents;

customElements.define('collection-component', StandardEvents.createViewEventElement());
customElements.define(
  'product-component',
  StandardEvents.createViewEventElement(HTMLElement, { defaultTrigger: 'intersect' }),
);

document.addEventListener(
  'DOMContentLoaded',
  () => {
    const template = document.querySelector('main[data-template]')?.dataset.template || '';
    document.dispatchEvent(
      new StandardEvents.PageViewEvent({
        page: { template, title: document.title, url: window.location.href },
      }),
    );
  },
  { once: true },
);
